import * as firebase from 'firebase';
require("firebase/firestore");

var collectionMeta={}

module.exports=collectionMeta;


// WEBPACK FOOTER //
// ./src/config/firestoreschema.js